import { ActionTree } from "vuex";
import { UserState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<UserState, RootState> = {};
